export default "__VITE_PUBLIC_ASSET__de57d785__"